import { Link } from 'react-router-dom';
import { Plus, type LucideIcon } from 'lucide-react';
import type { IpdOrderKind } from '@his/shared';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/primitives';
import { ShellSectionHeading } from '@/components/clinical-shell/ShellPanel';
import { admissionIsOpen, type Admission } from '../../admission/types';
import { OrderList } from './OrderList';

export function KindOrdersSection({
  admission,
  kind,
  icon,
  title,
  description,
  newOrderHref,
}: {
  admission: Admission;
  kind: IpdOrderKind;
  icon: LucideIcon;
  title: string;
  description: string;
  newOrderHref: string;
}) {
  const { can } = useAuth();
  return (
    <>
      <ShellSectionHeading
        icon={icon}
        title={title}
        description={description}
        actions={
          admissionIsOpen(admission) && can('cpoe.write') ? (
            <Link to={newOrderHref}>
              <Button size="sm">
                <Plus className="h-4 w-4" aria-hidden /> {tr('ipd', `io_ord_new_${kind}`)}
              </Button>
            </Link>
          ) : null
        }
      />
      <OrderList admission={admission} kind={kind} />
    </>
  );
}
